import axios from 'axios';
import url from '@/url';

export const getLiveSessions = async ({ scope = 'now' } = {}) => {
  const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.admin_live_sessions + `?scope=${encodeURIComponent(scope)}`, {
    headers: {
      'X-Authorization': localStorage.getItem('token'),
    },
  });

  if (response.data?.result?.status === 200) {
    return response.data.result.data || [];
  }
  return [];
};

export const joinLiveSession = async ({ sessionType, trackerId, mode }) => {
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + url.admin_live_sessions_join,
    { sessionType, trackerId, mode },
    {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    },
  );

  if (response.data?.result?.status === 200) {
    return response.data.result.data;
  }
  throw new Error('Failed to join session');
};

export const leaveLiveSession = async ({ joinId }) => {
  if (!joinId) return true;
  try {
    await axios.post(
      process.env.VUE_APP_SERVICE_URL + url.admin_live_sessions_leave,
      { joinId },
      {
        headers: {
          'X-Authorization': localStorage.getItem('token'),
        },
      },
    );
    return true;
  } catch (e) {
    console.warn('Failed to leave live session:', e?.response?.data || e?.message);
    return false;
  }
};


